import Vue from 'vue'
import Vuex from 'vuex'
import { persistence } from './storageAdapter'
import slugify from '../utils/slugify'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: process.env.VERSION,
    updateAvailable: false,
    worker: null,
    loaded: false,
    milestones: [],
    log: [],
  },
  mutations: {
    resetLog (state) {
      state.log = []
    },
    prependLogEntries (state, entries) {
      state.log = [...entries, ...state.log]
    },
    log (state, message, timestamp = new Date) {
      state.log.push({
        message,
        timestamp,
      })
    },
    loaded (state, toggle) {
      state.loaded = toggle
    },
    addMilestone (state, milestone) {
      state.milestones.push(Object.assign(milestone, {
        slug: slugify(milestone.title)
      }))
    },
    updateMilestone (state, milestone) {
      state.milestones.map(existing => {
        if (existing.id === milestone.id) {
          return milestone
        }
        return existing
      })
    },
    removeMilestone (state, milestone) {
      state.milestones = state.milestones.filter(item => item !== milestone)
    },
    hasUpdated (state) {
      state.updateAvailable = true
    },

    /**
     * @param state
     * @param worker {ServiceWorkerRegistration}
     */
    setWorker (state, worker) {
      state.worker = worker
    },
  },
  plugins: [persistence]
})
